import ICommunityOwnership from "../types/ICommunityOwnership";
import HttpService from "../../core/services/HttpService";
import ICommunityConfig from "../types/ICommunityConfig";
import OrganizationCommunity from "../../organization/models/OrganizationCommunity";
import { ILoadCommunityMgmtMembershipsFilter } from "../types/ILoadCommunityMgmtMembershipsFilter";
import { IPagedCommunityMgmtMemberships } from "../types/IPagedCommunityMgmtMemberships";
import { ICommunityStatistic } from "../types/ICommunityStatistic";
import { MembershipStatus } from "../types/MembershipStatus";
import IMembershipHistoryItem from "../types/IMembershipHistoryItem";

export const getMyMemberships = async (): Promise<OrganizationCommunity[]> => {
  const response = await HttpService.Instance.get(process.env.REACT_APP_API_URL + 'communities/memberships');
  if (response.ok) {
    return response.json();
  }
  throw new Error(`An error occurred while loading the current user's community memberships.`)
}

export const getCommunityOwnerships = async (): Promise<ICommunityOwnership[]> => {
  const response = await HttpService.Instance.get(`${process.env.REACT_APP_API_URL}communities/ownerships`);
  if (response.ok) {
    return response.json();
  }
  throw new Error('An error occurred while loading community ownerships.')
}

export const getCommunityManagementMemberships = async (filter: ILoadCommunityMgmtMembershipsFilter): Promise<IPagedCommunityMgmtMemberships> => {
  const url = new URL(`${process.env.REACT_APP_API_URL}community-management/${filter.communityCode}/memberships`);
  filter.statuses.forEach(status => {
    url.searchParams.append('statuses', status);
  })
  if (filter.entityName) {
    url.searchParams.set('entityName', filter.entityName);
  }
  if (filter.communityCode) {
    url.searchParams.set('communityCode', filter.communityCode);
  }
  if (filter.page) {
    url.searchParams.set('page', filter.page.toString());
  }
  if (filter.pageSize) {
    url.searchParams.set('pageSize', filter.pageSize.toString());
  }

  const response = await HttpService.Instance.get(url.toString());
  if (response.ok) {
    return response.json();
  }
  throw new Error('An error occurred while loading community admin memberships.')
}

export const requestCommunityMembership = async (communityCode: string): Promise<void> => {
  const response = await HttpService.Instance.post(`${process.env.REACT_APP_API_URL}communities/memberships`, communityCode);
  if (!response.ok) {
    throw new Error(`An error occurred while requesting a membership for community with code ${communityCode}.`)
  }
}

export const getCommunityConfig = async (communityCode: string): Promise<ICommunityConfig> => {
  const response = await HttpService.Instance.get(`${process.env.REACT_APP_API_URL}communities/${communityCode}`);
  if (response.ok) {
    return response.json();
  }
  throw new Error('An error occurred while loading the community config from sitecore.')
}

export const getCommunityStatistics = async (): Promise<ICommunityStatistic[]> => {
  const response = await HttpService.Instance.get(`${process.env.REACT_APP_API_URL}community-management/statistics`);
  if (response.ok) {
    return response.json();
  }
  throw new Error('An error occurred while loading the community statistics.')
}

export const updateMembershipStatus = async (communityCode: string, membershipId: number, newStatus: MembershipStatus) => {
  const requestBody = {
    status: newStatus
  };
  await HttpService.Instance.put(`${process.env.REACT_APP_API_URL}community-management/${communityCode}/memberships/${membershipId}`, requestBody);
}

export const getCommunityMembershipHistory = async (communityCode: string, membershipId: number): Promise<IMembershipHistoryItem[]> => {
  const url = `${process.env.REACT_APP_API_URL}community-management/${communityCode}/memberships/${membershipId}/history`;
  const response = await HttpService.Instance.get(url);
  if (response.ok) {
    return response.json();
  }
  throw new Error('An error occurred while loading community membership history.')
}


// WEBPACK FOOTER //
// ./src/modules/communities/api/communitiesApi.ts